// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1NzB1","tag":"tag-2KkJc"};